export default {
      id: "edit_keys-usage",
      viewBox: "0 0 24 17",
      url: __webpack_public_path__ + "img/icons.svg#edit_keys",
      toString: function () {
        return this.url;
      }
    }